import React from 'react'
import PropTypes from 'prop-types'
import muiThemeable from 'material-ui/styles/muiThemeable'
import { compose } from 'recompose'

const styleCustom = {
  all: {
    width: '20%',
    display: 'flex',
    flexDirection: 'column',
  },
  image: {
    textAlign: 'center',
    cursor: 'pointer',
  },
  label: {
    fontSize: 9,
    textAlign: 'center',
  }
}

const IconCustom = compose(
  muiThemeable(),
)(({
  source = '',
  label = '',
  onClick = () => {},
  styles,
  children,
  active,
  muiTheme: { palette },
  index,
}) => {
  return (
    <div style={styleCustom.all} onClick={()=> onClick()}>
      <div style={styleCustom.image}>
        <img
          src={source}
          style={{
            ...active === index && {
              border: `2px solid ${palette.accent1Color}`,
              borderRadius: 5,
            }
          }}
        />
      </div>
      {label !== '' &&
        <div style={Object.assign({}, styleCustom.label)}>
          {label}
        </div>
      }
    </div>
  )
})

IconCustom.propTypes = {}
IconCustom.defaultProps = {}

export default IconCustom


// WEBPACK FOOTER //
// ./src/components/icon/IconCustom.js